import script from "./AdminCreateAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreateAccountView.vue?vue&type=script&setup=true&lang=js"

import "./AdminCreateAccountView.vue?vue&type=style&index=0&id=d435dadc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d435dadc"]])

export default __exports__